/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 60px 40px;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */

  color: #fff;

  h1 {
    margin-bottom: 15px;
    font-size: 24px;
  }

  h2 {
    margin-bottom: 15px;
    font-size: 22px;
  }

  p {
    margin-left: 20px;
    margin-bottom: 5px;
    font-size: 20px;
  }

  div.answer {
    margin-top: 40px;

    p {
      margin-left: 20px;
      margin-bottom: 5px;
      font-size: 24px;
    }
  }

  div.feedback {
    margin-top: 40px;
    margin-bottom: 40px;

    p {
      margin-left: 20px;
      margin-bottom: 5px;
      font-size: 20px;
    }
  }

  div.ace {
    background: #000;
    width: 400px;
  }

  div.form {
    margin: 0 auto;
    border-top-width: 1px;
    border-top-style: dashed;
    border-top-color: #aaa;
    padding: 30px 10px;

    form {
      width: 100%;

      input {
        width: 85%;
        height: 50px;
        border: 1px solid #000;
        border-radius: 4px;
        padding-left: 10px;
      }

      button.submitCode {
        margin-top: 20px;
        margin-left: 10px;
        height: 50px;
        width: 780px;
        background: #36ded6;
        font-weight: bold;
        color: #090f35;
        border: 0;
        border-radius: 5px;
        font-size: 14px;
        transition: background 0.2s;

        &:hover {
          background: ${darken(0.08, '#36ded6')};
        }
      }

      button.submitAnswer {
        margin-top: 20px;
        margin-left: 10px;
        height: 50px;
        width: 100px;
        background: #36ded6;
        font-weight: bold;
        color: #090f35;
        border: 0;
        border-radius: 5px;
        font-size: 14px;
        transition: background 0.2s;

        &:hover {
          background: ${darken(0.08, '#36ded6')};
        }
      }

      textarea {
        width: 100%;
        height: 300px;
        resize: none;
        background-color: #222;
        border: 1px solid #222;
        padding-top: 30px;
        padding-left: 30px;
        font-size: 20px;
        color: #fff;
      }
    }
  }
`;
